<template>
    <div>
        <div class="topbar">
            <Startups></Startups>

            <div class="topbar__inner">
                <div class="topbar__key">
                    <header class="topbar__key__header">
                        Showing
                        <select v-if="totalRowsCount >= 25" class="topbar__key__select" v-model="pageLength">
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                        </select>
                        <template v-else>{{totalRowsCount}}</template>

                        of {{totalRowsCount}} startups
                    </header>

                    <footer class="topbar__key__footer">
                        <ul class="topbar__side actions-list">
                            <li class="actions-list__add"><a class="" @click="addStartup">Add Startups</a></li>
                        </ul>
                    </footer>
                </div>
            </div>
        </div>

        <div class="main-table-wrapper overflow-auto">
            <div class="main-table">
                <Grid
                    :columns="columns"
                    :data="startups"
                    :addCellData="addCellData"
                    :page-length="parseInt(pageLength)"
                    :total-rows-count="totalRowsCount"
                    :sort="sort"
                    :currentPage="currentPage"
                    v-on:changePage="changePage"
                    v-on:changeSort="changeSort"
                    v-on:action="gridAction"
                >
                </Grid>
            </div>
        </div>

        <add-startups-to-portfolio
            ref="addStartupsToPortfolio"
            :startups="selectedStartups">
        </add-startups-to-portfolio>

        <Invite
            ref="invite"
            v-on:invited="getList"
        >
        </Invite>
    </div>
</template>

<script>
import grid from "@/mixins/grid";
import startups from "@/services/ecosystem/startups.service";
import Grid from "@/components/Grid";
import addStartupsToPortfolio from "@/components/startups/AddToPortfolios";
import Startups from "@/views/ecosystem/Startups";
import Invite from "@/components/startups/InviteStartup";

export default {
    mixins: [grid],

    components: {
        Grid,
        addStartupsToPortfolio,
        Startups,
        Invite,
    },

    data() {
        return {
            startups: [],

            columns: [
                {
                    label: 'Name',
                    name: 'name',
                    component: 'SearchCompanyNameColumn',
                },
                {
                    label: 'Stage',
                    name: 'stage',
                },
                {
                    label: 'Location',
                    name: 'location',
                    component: 'SearchCompanyLocationColumn',
                },
                {
                    label: 'Total Raised',
                    name: 'total_raised',
                },
                {
                    label: 'Projects',
                    name: 'projects',
                    component: 'RawColumn',
                },
                {
                    label: 'Status',
                    name: 'status',
                    component: 'InviteStatusColumn',
                },
                {
                    name: 'actions',
                    label: 'Actions',
                    component: 'Actions',
                }
            ],

            addCellData: {
                companyType: "startups",
            },

            selectedStartups: [],
        }
    },

    mounted() {
        this.getList()

        this.$store.watch(state => {
            if (state.needUpdateStartups) {
                this.getList()
            }
        })
    },

    methods: {
        getList() {
            let columns = this.arrayHelper.arrayColumn(this.columns, 'name')
            let currentPage = this.currentPage
            let pageLength = this.pageLength
            let sort = this.sort

            startups.getStartups({columns, sort, currentPage, pageLength}).then(response => {
                this.startups = response.data.data
                this.totalRowsCount = parseInt(response.data.total_count)
                this.currentPage = response.data.current_page
            })
        },

        gridAction(params) {
            if (params.action == 'delete') {

                if (confirm("Remove startup?")) {
                    startups.delete([params.rowId]).then(() => {
                        this.getList()
                    })
                }
            }

            if (params.action == 'add-to-portfolio') {
                this.selectedStartups = [params.rowId]
                this.$refs.addStartupsToPortfolio.open(params.rowId)
            }

            if (params.action == 'invite') {
                this.$refs.invite.open(params.rowId)
            }
        },

        addStartup() {
            this.$store.commit('setAddStartup', true);
            this.$nextTick(() => {
                this.$store.commit('setAddStartup', false);
            })
        }
    }
}
</script>

<style scoped>

</style>